import ReactMapGL, { Marker, Layer, LayerProps } from 'react-map-gl';
import * as React from 'react';
import 'mapbox-gl/dist/mapbox-gl.css';
import { DEFAULT_CENTER } from '../../../common/constants';
import { ICabinetInfo, INodeInfo } from '.';
import CabinetMarker from './cabinetMarker';
import NodeMarker from './NodeMarker';

interface ICustomMapProps {
  data: ICabinetInfo[]
  nodeData: INodeInfo[]
  handleClick: (cabinet: ICabinetInfo) => void;
  handleNodeClick: (node: INodeInfo) => void;
  isModalOpen?: boolean;
}

const CustomMap: React.FunctionComponent<ICustomMapProps> = ({ data, nodeData, handleClick, handleNodeClick, isModalOpen = false }) => {
  const [viewport, setViewport] = React.useState({
    latitude: DEFAULT_CENTER[0],
    longitude: DEFAULT_CENTER[1],
    zoom: 15,
  });

  // Calculate adjusted viewport when modal is open
  const adjustedViewport = React.useMemo(() => {
    if (isModalOpen) {
      // Move the map to the left when modal is open
      // Assuming modal takes up roughly 1/3 of the screen width
      const offset = 0.005; // Adjust this value to control how much the map moves left
      return {
        ...viewport,
        longitude: viewport.longitude + offset
      };
    }
    return viewport;
  }, [viewport, isModalOpen]);
  const layerStyleTheLines: LayerProps = {
    id: 'routeLayer',
    type: 'line',
    source: 'routeSource',
    layout: { "line-join": 'round', "line-cap": 'round' },
    paint: {
      'line-color': ['get', 'color'],
      'line-width': 8,
    }
  };

  return <div className='relative'>
    <div style={{ height: "100vh", width: "100%" }}>
      <ReactMapGL mapboxAccessToken="pk.eyJ1IjoibmdvdHJhMjcxMCIsImEiOiJjbHdmeGxqZHAxNm5jMm5vOW45MThnMmw0In0.DJjz-BZviJ6J1juoHl7rig" mapStyle="mapbox://styles/mapbox/streets-v12" scrollZoom={true} doubleClickZoom={true} {...adjustedViewport}
        onMove={evt => setViewport(evt.viewState)}>
        {data && <>
          {data.map((d, id) => {
            if (!d.location?.coordinates) return;
            return <Marker latitude={d.location?.coordinates[1]} longitude={d.location?.coordinates[0]} anchor='bottom' key={`cabinet-${id}`}>
              <CabinetMarker
                id={d.id}
                cabinet={d}
                zoom={viewport.zoom}
                handleClick={handleClick}
              />
            </Marker>
          })}
        </>}
        {nodeData && <>
          {nodeData.map((node, id) => {
            if (!node.nodeParams?.location?.coordinates) return;
            return <Marker latitude={node.nodeParams.location.coordinates[1]} longitude={node.nodeParams.location.coordinates[0]} anchor='bottom' key={`node-${id}`}>
              <NodeMarker
                id={node.nodes.id}
                node={node}
                zoom={viewport.zoom}
                handleClick={handleNodeClick}
              />
            </Marker>
          })}
        </>}
        <Layer {...layerStyleTheLines} />
      </ReactMapGL>
    </div>
  </div>;
};

export default CustomMap;
